var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf,
  __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function () {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = {
    exports: {}
  }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from == "object" || typeof from == "function") for (let key of __getOwnPropNames(from)) !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, {
    get: () => from[key],
    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
  });
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
  value: mod,
  enumerable: !0
}) : target, mod));
var require_freeGlobal = __commonJS({
  "../../node_modules/lodash/_freeGlobal.js"(exports, module) {
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module.exports = freeGlobal;
  }
});
var require_root = __commonJS({
  "../../node_modules/lodash/_root.js"(exports, module) {
    var freeGlobal = require_freeGlobal(),
      freeSelf = typeof self == "object" && self && self.Object === Object && self,
      root = freeGlobal || freeSelf || Function("return this")();
    module.exports = root;
  }
});
var require_Symbol = __commonJS({
  "../../node_modules/lodash/_Symbol.js"(exports, module) {
    var root = require_root(),
      Symbol2 = root.Symbol;
    module.exports = Symbol2;
  }
});
var require_arrayMap = __commonJS({
  "../../node_modules/lodash/_arrayMap.js"(exports, module) {
    function arrayMap(array, iteratee) {
      for (var index = -1, length = array == null ? 0 : array.length, result = Array(length); ++index < length;) result[index] = iteratee(array[index], index, array);
      return result;
    }
    module.exports = arrayMap;
  }
});
var require_isArray = __commonJS({
  "../../node_modules/lodash/isArray.js"(exports, module) {
    var isArray = Array.isArray;
    module.exports = isArray;
  }
});
var require_getRawTag = __commonJS({
  "../../node_modules/lodash/_getRawTag.js"(exports, module) {
    var Symbol2 = require_Symbol(),
      objectProto = Object.prototype,
      hasOwnProperty = objectProto.hasOwnProperty,
      nativeObjectToString = objectProto.toString,
      symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = !0;
      } catch (e) {}
      var result = nativeObjectToString.call(value);
      return unmasked && (isOwn ? value[symToStringTag] = tag : delete value[symToStringTag]), result;
    }
    module.exports = getRawTag;
  }
});
var require_objectToString = __commonJS({
  "../../node_modules/lodash/_objectToString.js"(exports, module) {
    var objectProto = Object.prototype,
      nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString;
  }
});
var require_baseGetTag = __commonJS({
  "../../node_modules/lodash/_baseGetTag.js"(exports, module) {
    var Symbol2 = require_Symbol(),
      getRawTag = require_getRawTag(),
      objectToString = require_objectToString(),
      nullTag = "[object Null]",
      undefinedTag = "[object Undefined]",
      symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      return value == null ? value === void 0 ? undefinedTag : nullTag : symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module.exports = baseGetTag;
  }
});
var require_isObjectLike = __commonJS({
  "../../node_modules/lodash/isObjectLike.js"(exports, module) {
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module.exports = isObjectLike;
  }
});
var require_isSymbol = __commonJS({
  "../../node_modules/lodash/isSymbol.js"(exports, module) {
    var baseGetTag = require_baseGetTag(),
      isObjectLike = require_isObjectLike(),
      symbolTag = "[object Symbol]";
    function isSymbol(value) {
      return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }
    module.exports = isSymbol;
  }
});
var require_baseToString = __commonJS({
  "../../node_modules/lodash/_baseToString.js"(exports, module) {
    var Symbol2 = require_Symbol(),
      arrayMap = require_arrayMap(),
      isArray = require_isArray(),
      isSymbol = require_isSymbol(),
      INFINITY = 1 / 0,
      symbolProto = Symbol2 ? Symbol2.prototype : void 0,
      symbolToString = symbolProto ? symbolProto.toString : void 0;
    function baseToString(value) {
      if (typeof value == "string") return value;
      if (isArray(value)) return arrayMap(value, baseToString) + "";
      if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
      var result = value + "";
      return result == "0" && 1 / value == -INFINITY ? "-0" : result;
    }
    module.exports = baseToString;
  }
});
var require_toString = __commonJS({
  "../../node_modules/lodash/toString.js"(exports, module) {
    var baseToString = require_baseToString();
    function toString(value) {
      return value == null ? "" : baseToString(value);
    }
    module.exports = toString;
  }
});
var require_baseSlice = __commonJS({
  "../../node_modules/lodash/_baseSlice.js"(exports, module) {
    function baseSlice(array, start, end) {
      var index = -1,
        length = array.length;
      start < 0 && (start = -start > length ? 0 : length + start), end = end > length ? length : end, end < 0 && (end += length), length = start > end ? 0 : end - start >>> 0, start >>>= 0;
      for (var result = Array(length); ++index < length;) result[index] = array[index + start];
      return result;
    }
    module.exports = baseSlice;
  }
});
var require_castSlice = __commonJS({
  "../../node_modules/lodash/_castSlice.js"(exports, module) {
    var baseSlice = require_baseSlice();
    function castSlice(array, start, end) {
      var length = array.length;
      return end = end === void 0 ? length : end, !start && end >= length ? array : baseSlice(array, start, end);
    }
    module.exports = castSlice;
  }
});
var require_hasUnicode = __commonJS({
  "../../node_modules/lodash/_hasUnicode.js"(exports, module) {
    var rsAstralRange = "\\ud800-\\udfff",
      rsComboMarksRange = "\\u0300-\\u036f",
      reComboHalfMarksRange = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange = "\\u20d0-\\u20ff",
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsVarRange = "\\ufe0e\\ufe0f",
      rsZWJ = "\\u200d",
      reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }
    module.exports = hasUnicode;
  }
});
var require_asciiToArray = __commonJS({
  "../../node_modules/lodash/_asciiToArray.js"(exports, module) {
    function asciiToArray(string) {
      return string.split("");
    }
    module.exports = asciiToArray;
  }
});
var require_unicodeToArray = __commonJS({
  "../../node_modules/lodash/_unicodeToArray.js"(exports, module) {
    var rsAstralRange = "\\ud800-\\udfff",
      rsComboMarksRange = "\\u0300-\\u036f",
      reComboHalfMarksRange = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange = "\\u20d0-\\u20ff",
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsVarRange = "\\ufe0e\\ufe0f",
      rsAstral = "[" + rsAstralRange + "]",
      rsCombo = "[" + rsComboRange + "]",
      rsFitz = "\\ud83c[\\udffb-\\udfff]",
      rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")",
      rsNonAstral = "[^" + rsAstralRange + "]",
      rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      rsZWJ = "\\u200d",
      reOptMod = rsModifier + "?",
      rsOptVar = "[" + rsVarRange + "]?",
      rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*",
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")",
      reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }
    module.exports = unicodeToArray;
  }
});
var require_stringToArray = __commonJS({
  "../../node_modules/lodash/_stringToArray.js"(exports, module) {
    var asciiToArray = require_asciiToArray(),
      hasUnicode = require_hasUnicode(),
      unicodeToArray = require_unicodeToArray();
    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    module.exports = stringToArray;
  }
});
var require_createCaseFirst = __commonJS({
  "../../node_modules/lodash/_createCaseFirst.js"(exports, module) {
    var castSlice = require_castSlice(),
      hasUnicode = require_hasUnicode(),
      stringToArray = require_stringToArray(),
      toString = require_toString();
    function createCaseFirst(methodName) {
      return function (string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : void 0,
          chr = strSymbols ? strSymbols[0] : string.charAt(0),
          trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
      };
    }
    module.exports = createCaseFirst;
  }
});
var require_upperFirst = __commonJS({
  "../../node_modules/lodash/upperFirst.js"(exports, module) {
    var createCaseFirst = require_createCaseFirst(),
      upperFirst = createCaseFirst("toUpperCase");
    module.exports = upperFirst;
  }
});
var require_capitalize = __commonJS({
  "../../node_modules/lodash/capitalize.js"(exports, module) {
    var toString = require_toString(),
      upperFirst = require_upperFirst();
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }
    module.exports = capitalize;
  }
});
var require_arrayReduce = __commonJS({
  "../../node_modules/lodash/_arrayReduce.js"(exports, module) {
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index = -1,
        length = array == null ? 0 : array.length;
      for (initAccum && length && (accumulator = array[++index]); ++index < length;) accumulator = iteratee(accumulator, array[index], index, array);
      return accumulator;
    }
    module.exports = arrayReduce;
  }
});
var require_basePropertyOf = __commonJS({
  "../../node_modules/lodash/_basePropertyOf.js"(exports, module) {
    function basePropertyOf(object) {
      return function (key) {
        return object == null ? void 0 : object[key];
      };
    }
    module.exports = basePropertyOf;
  }
});
var require_deburrLetter = __commonJS({
  "../../node_modules/lodash/_deburrLetter.js"(exports, module) {
    var basePropertyOf = require_basePropertyOf(),
      deburredLetters = {
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      },
      deburrLetter = basePropertyOf(deburredLetters);
    module.exports = deburrLetter;
  }
});
var require_deburr = __commonJS({
  "../../node_modules/lodash/deburr.js"(exports, module) {
    var deburrLetter = require_deburrLetter(),
      toString = require_toString(),
      reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,
      rsComboMarksRange = "\\u0300-\\u036f",
      reComboHalfMarksRange = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange = "\\u20d0-\\u20ff",
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsCombo = "[" + rsComboRange + "]",
      reComboMark = RegExp(rsCombo, "g");
    function deburr(string) {
      return string = toString(string), string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
    }
    module.exports = deburr;
  }
});
var require_asciiWords = __commonJS({
  "../../node_modules/lodash/_asciiWords.js"(exports, module) {
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }
    module.exports = asciiWords;
  }
});
var require_hasUnicodeWord = __commonJS({
  "../../node_modules/lodash/_hasUnicodeWord.js"(exports, module) {
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }
    module.exports = hasUnicodeWord;
  }
});
var require_unicodeWords = __commonJS({
  "../../node_modules/lodash/_unicodeWords.js"(exports, module) {
    var rsAstralRange = "\\ud800-\\udfff",
      rsComboMarksRange = "\\u0300-\\u036f",
      reComboHalfMarksRange = "\\ufe20-\\ufe2f",
      rsComboSymbolsRange = "\\u20d0-\\u20ff",
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = "\\u2700-\\u27bf",
      rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff",
      rsMathOpRange = "\\xac\\xb1\\xd7\\xf7",
      rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",
      rsPunctuationRange = "\\u2000-\\u206f",
      rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
      rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde",
      rsVarRange = "\\ufe0e\\ufe0f",
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange,
      rsApos = "['\u2019]",
      rsBreak = "[" + rsBreakRange + "]",
      rsCombo = "[" + rsComboRange + "]",
      rsDigits = "\\d+",
      rsDingbat = "[" + rsDingbatRange + "]",
      rsLower = "[" + rsLowerRange + "]",
      rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]",
      rsFitz = "\\ud83c[\\udffb-\\udfff]",
      rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")",
      rsNonAstral = "[^" + rsAstralRange + "]",
      rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
      rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
      rsUpper = "[" + rsUpperRange + "]",
      rsZWJ = "\\u200d",
      rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")",
      rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")",
      rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?",
      rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?",
      reOptMod = rsModifier + "?",
      rsOptVar = "[" + rsVarRange + "]?",
      rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*",
      rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",
      rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq,
      reUnicodeWord = RegExp([rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")", rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")", rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower, rsUpper + "+" + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join("|"), "g");
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }
    module.exports = unicodeWords;
  }
});
var require_words = __commonJS({
  "../../node_modules/lodash/words.js"(exports, module) {
    var asciiWords = require_asciiWords(),
      hasUnicodeWord = require_hasUnicodeWord(),
      toString = require_toString(),
      unicodeWords = require_unicodeWords();
    function words(string, pattern, guard) {
      return string = toString(string), pattern = guard ? void 0 : pattern, pattern === void 0 ? hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string) : string.match(pattern) || [];
    }
    module.exports = words;
  }
});
var require_createCompounder = __commonJS({
  "../../node_modules/lodash/_createCompounder.js"(exports, module) {
    var arrayReduce = require_arrayReduce(),
      deburr = require_deburr(),
      words = require_words(),
      rsApos = "['\u2019]",
      reApos = RegExp(rsApos, "g");
    function createCompounder(callback) {
      return function (string) {
        return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
      };
    }
    module.exports = createCompounder;
  }
});
var require_camelCase = __commonJS({
  "../../node_modules/lodash/camelCase.js"(exports, module) {
    var capitalize = require_capitalize(),
      createCompounder = require_createCompounder(),
      camelCase2 = createCompounder(function (result, word, index) {
        return word = word.toLowerCase(), result + (index ? capitalize(word) : word);
      });
    module.exports = camelCase2;
  }
});
var BACKGROUND_PROPS = ["background", "backgroundColor", "backgroundImage", "backgroundSize", "backgroundPosition", "backgroundRepeat", "backgroundAttachment"];
var BORDER_RADIUS_PROPS = ["borderRadius", "borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
  BORDER_WIDTH_PROPS = ["borderWidth", "borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
  BORDER_COLOR_PROPS = ["borderColor", "borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
  BORDER_STYLE_PROPS = ["borderStyle", "borderTopStyle", "borderRightStyle", "borderBottomStyle", "borderLeftStyle"],
  BORDER_PROPS = [...BORDER_RADIUS_PROPS, ...BORDER_WIDTH_PROPS, ...BORDER_COLOR_PROPS, ...BORDER_STYLE_PROPS, "border", "borderTop", "borderRight", "borderBottom", "borderLeft", "borderX", "borderY"];
var FLEXBOX_PROPS = ["alignContent", "alignItems", "alignSelf", "flex", "flexBasis", "flexDirection", "flexGrow", "flexShrink", "flexWrap", "justifyContent", "justifyItems", "justifySelf", "order"];
var GRID_PROPS = ["gridColumn", "gridRow", "gridAutoFlow", "gridAutoColumns", "gridAutoRows", "gridTemplateColumns", "gridTemplateRows", "gridTemplateAreas", "gridArea"];
var OVERFLOW_PROPS = ["overflow", "overflowX", "overflowY"],
  LAYOUT_PROPS = [...OVERFLOW_PROPS, "width", "minWidth", "maxWidth", "height", "minHeight", "maxHeight", "size", "display", "verticalAlign"];
var POSITION_PROPS = ["position", "left", "right", "top", "bottom", "zIndex"];
var SHADOW_PROPS = ["boxShadow", "textShadow"];
var MARGIN_PROPS = ["margin", "m", "marginTop", "mt", "marginRight", "mr", "marginBottom", "mb", "marginLeft", "ml", "marginX", "mx", "marginY", "my"],
  PADDING_PROPS = ["padding", "p", "paddingTop", "pt", "paddingRight", "pr", "paddingBottom", "pb", "paddingLeft", "pl", "paddingX", "px", "paddingY", "py"],
  GAP_PROPS = ["columnGap", "rowGap"],
  SPACE_PROPS = [...MARGIN_PROPS, ...PADDING_PROPS, ...GAP_PROPS];
var TYPOGRAPHY_PROPS = ["fontFamily", "fontSize", "fontStyle", "fontWeight", "letterSpacing", "lineHeight", "textAlign", "color", "textDecoration", "textOverflow", "textTransform", "whiteSpace", "wordBreak", "wordWrap", "overflowWrap"];
import { DefaultTheme } from "@twilio-paste/theme";
var propValidator = optionsList => (props, propName, componentName) => {
  let suppliedValue = props[propName],
    propError = new Error("[".concat(componentName, "]: invalid prop supplied \"").concat(propName, "=").concat(suppliedValue, "\", expected a token value. See https://paste.twilio.design/tokens for available options.")),
    isInvalidToken = value => !optionsList.includes(value);
  if (suppliedValue != null) {
    if (Array.isArray(suppliedValue)) {
      for (let value of suppliedValue) if (isInvalidToken(value)) return propError;
    } else if (isInvalidToken(suppliedValue)) return propError;
  }
  return null;
};
var import_camelCase = __toESM(require_camelCase());
import RawJSON from "@twilio-paste/design-tokens/dist/tokens.raw.json";
var DEPRECATE_TOKENS = Object.values(RawJSON.props).filter(token => token.deprecated).map(deprecatedToken => (0, import_camelCase.default)(deprecatedToken.name));
var BackgroundColorOptions = ["none", "transparent", ...Object.keys(DefaultTheme.backgroundColors)],
  isBackgroundColorTokenProp = propValidator(BackgroundColorOptions),
  isDeprecatedBackgroundColorTokenProp = props => (props.backgroundColor != null && DEPRECATE_TOKENS.indexOf(props.backgroundColor) > 0 && console.error("Paste: \"".concat(props.backgroundColor, "\" is a deprecated design token. It will be removed in the 2021.11.16 release of Paste")), null);
import { DefaultTheme as DefaultTheme2 } from "@twilio-paste/theme";
var BorderRadiusOptions = Object.keys(DefaultTheme2.radii),
  BorderWidthOptions = Object.keys(DefaultTheme2.borderWidths),
  BorderColorOptions = ["transparent", ...Object.keys(DefaultTheme2.borderColors)],
  isBorderRadiusTokenProp = propValidator(BorderRadiusOptions),
  isBorderWidthTokenProp = propValidator(BorderWidthOptions),
  isBorderColorTokenProp = propValidator(BorderColorOptions),
  isDeprecatedBorderColorTokenProp = props => (props.borderColor != null && DEPRECATE_TOKENS.indexOf(props.borderColor) > 0 && console.error("Paste: \"".concat(props.borderColor, "\" is a deprecated design token. It will be removed in the 2021.11.16 release of Paste")), null);
import PropTypes2 from "prop-types";
import { DefaultTheme as DefaultTheme3 } from "@twilio-paste/theme";
import PropTypes from "prop-types";
var ResponsiveProp = type => PropTypes.oneOfType([type, PropTypes.arrayOf(type)]);
var IconSizeOptions = Object.keys(DefaultTheme3.iconSizes),
  isWidthTokenProp = ResponsiveProp(PropTypes2.oneOfType([PropTypes2.string, PropTypes2.number])),
  isMinWidthTokenProp = ResponsiveProp(PropTypes2.oneOfType([PropTypes2.string, PropTypes2.number])),
  isMaxWidthTokenProp = ResponsiveProp(PropTypes2.oneOfType([PropTypes2.string, PropTypes2.number])),
  isHeightTokenProp = ResponsiveProp(PropTypes2.oneOfType([PropTypes2.string, PropTypes2.number])),
  isMinHeightTokenProp = ResponsiveProp(PropTypes2.oneOfType([PropTypes2.string, PropTypes2.number])),
  isMaxHeightTokenProp = ResponsiveProp(PropTypes2.oneOfType([PropTypes2.string, PropTypes2.number])),
  isIconSizeTokenProp = propValidator(IconSizeOptions);
import { DefaultTheme as DefaultTheme4 } from "@twilio-paste/theme";
var ZIndexOptions = Object.keys(DefaultTheme4.zIndices),
  isZIndexTokenProp = propValidator(ZIndexOptions);
import { DefaultTheme as DefaultTheme5 } from "@twilio-paste/theme";
var BoxShadowOptions = ["none", ...Object.keys(DefaultTheme5.shadows)],
  isBoxShadowTokenProp = propValidator(BoxShadowOptions),
  isDeprecatedBoxShadowTokenProp = props => (props.boxShadow != null && DEPRECATE_TOKENS.indexOf(props.boxShadow) > 0 && console.error("Paste: \"".concat(props.boxShadow, "\" is a deprecated design token. It will be removed in the 2021.11.16 release of Paste")), null);
import { DefaultTheme as DefaultTheme6 } from "@twilio-paste/theme";
var SpaceOptions = Object.keys(DefaultTheme6.space),
  MarginOptions = ["auto", ...Object.keys(DefaultTheme6.space)],
  isSpaceTokenProp = propValidator(SpaceOptions),
  isPaddingTokenProp = propValidator(SpaceOptions),
  isMarginTokenProp = propValidator(MarginOptions),
  isGapTokenProp = propValidator(SpaceOptions);
import { DefaultTheme as DefaultTheme7 } from "@twilio-paste/theme";
var FontFamilyOptions = ["inherit", ...Object.keys(DefaultTheme7.fonts)],
  FontSizeOptions = ["100%", "inherit", ...Object.keys(DefaultTheme7.fontSizes)],
  FontWeightOptions = ["inherit", ...Object.keys(DefaultTheme7.fontWeights)],
  LineHeightOptions = ["unset", "inherit", ...Object.keys(DefaultTheme7.lineHeights)],
  TextColorOptions = ["currentColor", "inherit", ...Object.keys(DefaultTheme7.textColors)],
  isFontFamilyTokenProp = propValidator(FontFamilyOptions),
  isFontSizeTokenProp = propValidator(FontSizeOptions),
  isFontWeightTokenProp = propValidator(FontWeightOptions),
  isLineHeightTokenProp = propValidator(LineHeightOptions),
  isTextColorTokenProp = propValidator(TextColorOptions),
  isDeprecatedTextColorTokenProp = props => (props.color != null && DEPRECATE_TOKENS.indexOf(props.color) > 0 && console.error("Paste: \"".concat(props.color, "\" is a deprecated design token. It will be removed in the 2021.11.16 release of Paste")), null);
import PropTypes3 from "prop-types";
var StyleResetProp = PropTypes3.oneOf(["none", "inherit", "initial", "unset"]);
export { BACKGROUND_PROPS, BORDER_COLOR_PROPS, BORDER_PROPS, BORDER_RADIUS_PROPS, BORDER_STYLE_PROPS, BORDER_WIDTH_PROPS, FLEXBOX_PROPS, GAP_PROPS, GRID_PROPS, LAYOUT_PROPS, MARGIN_PROPS, OVERFLOW_PROPS, PADDING_PROPS, POSITION_PROPS, ResponsiveProp, SHADOW_PROPS, SPACE_PROPS, StyleResetProp, TYPOGRAPHY_PROPS, isBackgroundColorTokenProp, isBorderColorTokenProp, isBorderRadiusTokenProp, isBorderWidthTokenProp, isBoxShadowTokenProp, isDeprecatedBackgroundColorTokenProp, isDeprecatedBorderColorTokenProp, isDeprecatedBoxShadowTokenProp, isDeprecatedTextColorTokenProp, isFontFamilyTokenProp, isFontSizeTokenProp, isFontWeightTokenProp, isGapTokenProp, isHeightTokenProp, isIconSizeTokenProp, isLineHeightTokenProp, isMarginTokenProp, isMaxHeightTokenProp, isMaxWidthTokenProp, isMinHeightTokenProp, isMinWidthTokenProp, isPaddingTokenProp, isSpaceTokenProp, isTextColorTokenProp, isWidthTokenProp, isZIndexTokenProp };